import { Box } from '@mui/system';
import React from 'react';
import LinkButton from '../../../components/Buttons/LinkButton';
import HorizontalWrapper from '../../../components/Details/HorizonticalWrapper';

export interface IPropsContinueProcess {
  details: any;
  link: string;
  label: string;
  renderOutsideReactRouter?: boolean;
}

const ContinueProcess = ({
  link,
  details,
  label,
  renderOutsideReactRouter,
}: IPropsContinueProcess) => {
  return (
    <>
      <HorizontalWrapper details={details} />
      <Box m={4} 
        justifyContent={'center'}
        display='flex'>
        <LinkButton
          renderOutsideReactRouter={renderOutsideReactRouter}
          link={link}
          label={label}
          externalLink
          color='primary'
          variant='contained'
          sx={{
            maxWidth: '350px',
            minWidth: '350px',
            maxHeight: '50px',
            minHeight: '50px',
          }}
        />
      </Box>
    </>
  );
};

export default ContinueProcess;
